<div class="selection-box-container">
	<div class="selection-box-bar">
		<cp-sb-bar [title]="options.title"
				   [searchable]="options.searchable"
				   [focus]="options.focus"
				   [diagramPath]="options.diagramPath"
				   [displayDiagram]="displayDiagram"
				   [disabled]="disabled"
				   [placeholderTranslationKey]="placeholderTranslationKey"
				   (searchItems)="onSearch($event)"
				   (diagramIconClick)="onDiagramIconClick()">
		</cp-sb-bar>
	</div>

	<div class="selection-box-content">
		<cp-sb-content [data]="options.data"
					   [subTitle]="options.subTitle"
					   [diagramPath]="options.diagramPath"
					   [displayDiagram]="displayDiagram"
					   [locateSelected]="options.locateSelected"
					   [itemTemplate]="itemTemplate"
					   [searchTerms]="searchTerms"
					   (selectItem)="onSelect($event)"
					   (actionClick)="onActionClick($event)"
					   (subTitleClick)="onSubTitleClick()">
		</cp-sb-content>
	</div>
</div>
